import { getGlobalConfig } from '@dealstack/frontend/shared/globalConfig';
import { redirectTo } from '@dealstack/frontend/shared/redirecting';
import {
	parseSessionEndReason,
	SESSION_END_REASON_PARAM,
	SessionEndReason,
} from '@dealstack/shared/lib/common/session/sessionContract';
import { ApplicationType } from '@dealstack/shared/lib/generated';
import { storeReturnPath } from './returnPath';

export const LOGIN_PATH = '/auth/login';

export const authStartUrl = (
	apiUrl: string,
	applicationType: ApplicationType,
	invitationToken?: string
): string => {
	const url = `${apiUrl}/auth/start?applicationType=${encodeURIComponent(applicationType)}`;

	if (!invitationToken) {
		return url;
	}

	return `${url}&invitationToken=${encodeURIComponent(invitationToken)}`;
};

const isLoginPath = (pathname: string): boolean =>
	(pathname.endsWith('/') ? pathname.slice(0, -1) : pathname) === LOGIN_PATH;

export const involuntarySessionEndReason = (search: URLSearchParams): SessionEndReason | null => {
	const reason = parseSessionEndReason(search.get(SESSION_END_REASON_PARAM));

	return reason && reason !== SessionEndReason.SIGNED_OUT ? reason : null;
};

export const startHostedAuthIfOnLoginRoute = (applicationType: ApplicationType): boolean => {
	if (!isLoginPath(window.location.pathname)) {
		return false;
	}

	const search = new URLSearchParams(window.location.search);

	if (involuntarySessionEndReason(search)) {
		return false;
	}

	const apiUrl = getGlobalConfig()?.apiUrl;

	if (!apiUrl) {
		return false;
	}

	storeReturnPath(search.get('redirectUrl'));
	redirectTo(authStartUrl(apiUrl, applicationType));

	return true;
};
